import React from "react";

const DeleteModalButtons = ({onDelete, onToggle}) => {
    return <>
        <button  onClick={onToggle} className={'cancel-button'}>Cancel</button>
        <button  onClick={onDelete} className={'close-button'}>Delete</button>{' '}
    </>
}

export default DeleteModalButtons